export enum PAYMENT_TYPE {
  CARD = 'card',
  INVOICE = 'invoice',
}
